import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import seo_45global from "/app/apps/frontend/src/middleware/seo.global.ts";
import tracking_45global from "/app/apps/frontend/src/middleware/tracking.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  seo_45global,
  tracking_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/apps/frontend/src/middleware/auth.ts"),
  global: () => import("/app/apps/frontend/src/middleware/global.ts"),
  guest: () => import("/app/apps/frontend/src/middleware/guest.ts")
}